import { render } from "./EmployeeProcessedRequests.vue?vue&type=template&id=a6bdcde4"
import script from "./EmployeeProcessedRequests.vue?vue&type=script&lang=js"
export * from "./EmployeeProcessedRequests.vue?vue&type=script&lang=js"

import "./EmployeeProcessedRequests.vue?vue&type=style&index=0&id=a6bdcde4&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__